export class Constants {
    public static readonly FISCAL_DATE_YEAR_2100 = 47482;  
}